import React, {useContext, useEffect} from 'react';
import {Alert, Button, Col, ConfigProvider, DatePicker, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../../styles/Colors";
import locale from "antd/es/locale/es_ES";
import {BiCheck, BiX} from "react-icons/bi";
import {AuthContext} from "../../../../config/AuthContext";
import TextArea from "antd/es/input/TextArea";
import toast, {Toaster} from "react-hot-toast";

interface IngredientModalProps {
    onClose: (value: boolean) => void;
    visible: boolean;
    infants: [];
    idCasal: string;
    idCampus: string;
    idOpcio: string;
}

const PassarLlistaInfantModal: React.FC<IngredientModalProps> = ({onClose, visible, infants, idCasal, idCampus, idOpcio}) => {
    const [form] = Form.useForm();
    const format = 'DD-MM-YYYY';

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    useEffect(() => {

    }, [idCasal, idCampus, idOpcio]);

    const handleCancel = () => {
        onClose(false);
    };

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        let newForm = {...formData, idCasal: idCasal, idCampus: idCampus, idOpcio: idOpcio,
                id_alumne: (formData.id_alumne === undefined ? 0 : formData.id_alumne),
                observacions: (formData.observacions === undefined ? '' : formData.observacions)
        };

        if (formData.observacions === undefined && formData.id_alumne === undefined) {
            toast.error("Especifica el nom de l'infant a les observacions");
        } else {

            console.log("Form Data:", newForm);
            console.log(JSON.stringify(newForm));

            /*const documentUrl = await PostLlistatsPdf(formData, page);
            //setDocumentUrlPdf(documentUrl);

            if (documentUrl && documentUrl !== "") {
                const link = document.createElement('a');
                link.href = documentUrl;
                link.download = `Llistat.pdf`;
                link.target = '_blank';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }*/

            //onClose(false);
        }
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="AFEGIR INFANT"
                open={visible}
                onCancel={handleCancel}
                footer={[]}
                width={1000}
            >
                <Toaster/>

                <Form form={form} onFinish={handleSubmit}>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Alert type={"info"} message={"Si no apareix al llistat de 'Infant' sel·lecciona: 'NO APAREIX A LA LLISTA'"} />
                            <br/>
                            <Form.Item label="Infant" name={"id_alumne"}>
                                <Select showSearch={true}
                                        placeholder="Selecciona Infant"
                                        defaultValue={0}
                                        optionFilterProp="label"
                                        options={[{value: 0, label: 'NO APAREIX A LA LLISTA (Especificar nom a observacions)'}, ...infants]}
                                />
                            </Form.Item>
                            <Form.Item label="Observacions" name={"observacions"}>
                                <TextArea />
                            </Form.Item>
                            <Form.Item label="Dia" name={"dia"}
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <DatePicker
                                    format={format}
                                    picker="date"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={4}>
                        </Col>
                        <Col span={2}>
                            <Form.Item>
                                <Button title={"Aceptar"} htmlType={"submit"}
                                        style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                        </Col>
                        <Col span={2}>
                            <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                    onClick={handleCancel}><BiX/></Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default PassarLlistaInfantModal;
